// import Vue from 'vue'
import * as types from '../mutation-types'
import { api } from '@/modules/api/index'

const state = {
  statusDisplayNames: []
}

const getters = {
  statusDisplayNames: state => state.statusDisplayNames
}

const actions = {
  async getStatusDisplayNames ({ commit }) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      const response = await this.$axios.get(api.statusDisplayNames.getStatusDisplayNames())
      commit(types.STATUS_DISPLAY_NAME, response.data)
    } catch (e) {
      commit(types.CREATE_ERROR_MESSAGE, 'Status display name wasn\'t get')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  },
  async updateStatusDisplayNames ({ commit }, payload) {
    try {
      commit(types.SET_SPINNER_STATUS, true)
      await this.$axios.put(api.statusDisplayNames.updateStatusDisplayNames(), payload)
      commit(types.CREATE_SUCCESS_MESSAGE, 'Status display name were uploaded successfully')
    } catch (e) {
      commit(types.CREATE_ERROR_MESSAGE, 'Status display name wasn\'t edited')
    } finally {
      commit(types.SET_SPINNER_STATUS, false)
    }
  }
}

const mutations = {
  [types.STATUS_DISPLAY_NAME] (state, { statusDisplayNames }) {
    state.statusDisplayNames = [...statusDisplayNames]
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/statusDisplayName.js